/* global  */ // tUrl等のグローバル変数を宣言する

import autoScroll from './functions/_autoScroll.js' // 自動スクロール
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Zoom, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Zoom]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
  ######  ##       #### ########  ########
 ##    ## ##        ##  ##     ## ##
 ##       ##        ##  ##     ## ##
  ######  ##        ##  ##     ## ######
       ## ##        ##  ##     ## ##
 ##    ## ##        ##  ##     ## ##
  ######  ######## #### ########  ########
*/
let scaleSlider = []
const scaleSliderItem = document.getElementsByClassName('js-scaleSlider')
if (scaleSliderItem[0]) {
  for (const targetSlider of scaleSliderItem) {
    const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
    scaleSliderInit(targetSlider, sliderName)
  }
}
function scaleSliderInit(targetSlider, sliderName) {
  scaleSlider[sliderName] = new Swiper(targetSlider, {
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 800, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },

    pagination: {
      // ページャーオプション
      el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true, // クリックでジャンプ可能にする
    },
  })

  const slideTriggers = document.getElementsByClassName('js-scaleSlider-trigger--' + sliderName)
  for (const slideTrigger of slideTriggers) {
    slideTrigger.addEventListener('transitionend', function (e) {
      scaleSlider[sliderName].slideNext()
    })
    slideTrigger.addEventListener('webkitTransitionend', function (e) {
      scaleSlider[sliderName].slideNext()
    })
  }
}

// 実績スライド
if ($('.js-worksSlide')[0]) {
  const sliderSelector = '.js-worksSlide' // スライダーのコンテナーとなる要素のセレクタ
  const slidesPerView = 3 // スライド表示数
  const $slide = $(sliderSelector + ' .swiper-slide')
  const slidable = $slide.length > slidesPerView
  const containerModifierClass = slidable ? 'is-active swiper-container-' : 'swiper-container-' // スライドがアクティブな場合は、コンテナー要素にクラス名「is-active」を設定
  // eslint-disable-next-line no-unused-vars
  const worksSlide = new Swiper('.js-worksSlide', {
    containerModifierClass: containerModifierClass,
    speed: 1000,
    // スライド数が足りない場合はloop: false, watchOverflow: true　でスライド無効に設定
    slidesPerView: 1,
    loop: slidable,
    navigation: {
      nextEl: '.js-worksSlide-next',
      prevEl: '.js-worksSlide-prev',
    },
    watchOverflow: true,
    breakpoints: {
      769: {
        slidesPerView: slidesPerView,
        spaceBetween: 24,
      },
    },
  })
}

// TOP インタビュースライダー
let officeSide
if (document.getElementsByClassName('js-officeSlide')) {
  // SP時だけスライダーにする
  let officeSideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    officeSideInit()
    officeSideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (officeSideActive && window.matchMedia('(min-width:769px)').matches) {
      officeSide.destroy()
      officeSideActive = false
    } else if (!officeSideActive && window.matchMedia('(max-width:768px)').matches) {
      officeSideInit()
      officeSideActive = true
    }
  })
}
function officeSideInit() {
  officeSide = new Swiper('.js-officeSlide', {
    loop: true,
    pagination: {
      el: '.js-officeSlide-pagination',
      type: 'bullets',
    },
  })
}

/*
    ##      ##  #######  ########  ##    ##  ######
    ##  ##  ## ##     ## ##     ## ##   ##  ##    ##
    ##  ##  ## ##     ## ##     ## ##  ##   ##
    ##  ##  ## ##     ## ########  #####     ######
    ##  ##  ## ##     ## ##   ##   ##  ##         ##
    ##  ##  ## ##     ## ##    ##  ##   ##  ##    ##
     ###  ###   #######  ##     ## ##    ##  ######
*/
$('.js-works-select').on('change', function () {
  if ($(this).val() !== '') {
    window.location.href = $(this).val()
  }
})

if ($('.js-worksArchiveImg-img')[0]) {
  $('.js-worksArchiveImg-img').each(function () {
    const imgWidth = $(this).width()
    const imgHeight = $(this).height()
    if (imgHeight > imgWidth / 1.73) {
      $(this).addClass('imgVertical')
    }
  })
}
if ($('.js-worksSingleImg-img')[0]) {
  const objImg = $('.js-worksSingleImg-img')
  const imgWidth = objImg.width()
  const imgHeight = objImg.height()
  if (imgHeight > imgWidth / 1.73) {
    objImg.addClass('imgVertical')
  }
}
if ($('.js-worksSingleThumb')[0]) {
  $('.js-worksSingleThumb').each(function () {
    const imgWidth = $(this).children('img').width()
    const imgHeight = $(this).children('img').height()
    if (imgHeight > imgWidth / 1.73) {
      $(this).children('img').addClass('imgVertical')
    }
  })
}

$('.js-worksSingleThumb').on('click', function () {
  $('.js-worksSingleThumb').removeClass('active')
  $(this).addClass('active')
  const src = $(this).children('.js-worksSingleThumb-img').attr('src')
  $('.js-worksSingleImg-img').attr('src', src)
  if ($(this).children('.js-worksSingleThumb-img').hasClass('imgVertical')) {
    $('.js-worksSingleImg-img').addClass('imgVertical')
  } else {
    $('.js-worksSingleImg-img').removeClass('imgVertical')
  }
})

/*
  ##     ##  #######  ##     ## #### ########
  #### #### ##     ## ##     ##  ##  ##
  ## ### ## ##     ## ##     ##  ##  ######
  ##     ## ##     ##  ##   ##   ##  ##
  ##     ##  #######     ###    #### ########
*/
$('.js-playMovie').on('click', function (e) {
  e.preventDefault()
  const movieId = $(this).attr('data-video')
  $(this)
    .parent()
    .html(
      '<div class="youtube-wrap"><iframe src="https://www.youtube.com/embed/' +
        movieId +
        '?autoplay=1&rel=0&controls=1&mute=1"></iframe></div>'
    )
})

/*
  ##     ##  #######  ########     ###    ##
  #### #### ##     ## ##     ##  ##   ##  ##
  ## ### ## ##     ## ##     ## ##     ## ##
  ##     ## ##     ## ##     ## ######### ##
  ##     ##  #######  ########  ##     ## ########
*/
$('.js-modal-open').on('click', function () {
  openModal($('#' + $(this).attr('data-modal')))
  return false
})
let scrollTop
// モーダル開く
function openModal(el) {
  let elModal = el
  let elModalContent = elModal.children('.js-modal-container')
  scrollTop = $(window).scrollTop()
  elModal.addClass('active')
  elModal.scrollTop(0)
  $('body').addClass('modalOn')
  $('body').css({ top: -1 * scrollTop })
  if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
    for (let i = 0; i < elModalContent.length; i++) {
      elModalContent[i].addEventListener(
        'touchmove',
        function (e) {
          const scroll = elModalContent.scrollTop
          const range = elModalContent.scrollHeight - elModalContent.offsetHeight - 1
          if (scroll < 1) {
            e.preventDefault()
            elModalContent.scrollTop = 1
          } else if (scroll > range) {
            e.preventDefault()
            elModalContent.scrollTop = range
          }
        },
        { passive: false }
      )
    }
  }
}
// モーダル閉じる
$('.js-modal-close').on('click', function () {
  closeModal($(this).closest('.js-modal'))
})
$('.js-modal').on('click', function () {
  closeModal($(this))
})
$('.js-modal-container').on('click', function (e) {
  e.stopPropagation()
})
function closeModal(el) {
  el.removeClass('active')
  $('body').removeClass('modalOn')
  $('body').css('top', 'auto')
  $(window).scrollTop(scrollTop)
}

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
if (document.getElementsByClassName('js-in')[0]) {
  intObs()
}
function intObs() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
scrollValToggle('#hogeID', 500, false,'active')
 */
scrollValToggle('#fixBtn', 0, 300, 'active')
scrollValToggle('#pagetop', 0, 1000, 'hide')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

/*
   ###          ##    ###    ##     ##
 ##   ##        ##  ##   ##    ## ##
##     ##       ## ##     ##    ###
######### ##    ## #########   ## ##
##     ##  ######  ##     ## ##     ##
*/
let ajax = false // Ajaxリクエスト
let ajaxResponse = '' // 最後のレスポンスを格納する

/*
        ##       #### ##    ## ##    ##
        ##        ##  ####  ## ##  ##
####### ##        ##  ## ## ## #####
        ##        ##  ##  #### ##  ##
        ######## #### ##    ## ##    ##

Aタグのリンク先と通信する
<a href="<?php echo termLink; ?>" class="js-linkAjax" data-from="#a" data-to="#a" data-push="on">

</a>
*/

if (document.getElementsByClassName('js-linkAjax')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-linkAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.attributes['href'].value // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      const flag = item.dataset.flag // 追加の処理フラグ
      applyAjax(url, 'GET', null, from, to, pushSt, type, scroll, flag)
    }
  })
}

/*
         ########  #######  ########  ##     ##
         ##       ##     ## ##     ## ###   ###
         ##       ##     ## ##     ## #### ####
 ####### ######   ##     ## ########  ## ### ##
         ##       ##     ## ##   ##   ##     ##
         ##       ##     ## ##    ##  ##     ##
         ##        #######  ##     ## ##     ##

フォーム送信して結果を反映する

<form action="hoge.php" method="POST" name="form-name">
  <button type="button" class="js-ajaxSubmit" data-form="form-name" data-input="type,item" data-require="" data-message="送信が完了しました。">
      更新
  </button>
</form>

*/

if (document.getElementsByClassName('js-ajaxSubmit')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-ajaxSubmit') && e.target.tagName === 'BUTTON') {
      e.preventDefault()
      ajaxSubmit(e.target)
    }
  })
}
if (document.getElementsByClassName('js-ajaxSubmit')[0]) {
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-ajaxSubmit')) {
      e.preventDefault()
      ajaxSubmit(e.target)
    }
  })
}

function ajaxSubmit(item) {
  let param = '' // 送信パラメータ
  const name = item.dataset.form
  const form = document.forms[name] // 指定nameのformに存在するinputにアクセス
  const url = form.action // 取得先
  const method = form.method // GET/POST

  const type = item.dataset.type // add(追加)もしくはrep(差し替え)
  const from = item.dataset.from // 取得要素
  const to = item.dataset.to // 差し替え要素
  const pushSt = item.dataset.push // URLのプッシュ
  const scroll = item.dataset.scroll // スクロール先

  // 指定されているinputを取得して送信データ化する
  const inputList = item.dataset.input.split(',') // ,区切りで配列に変換

  for (let index = 0; index < inputList.length; index++) {
    if (index !== 0) {
      param += '&'
    }
    const input = inputList[index]
    const valueList = document.querySelectorAll('form[name="' + name + '"] [name="' + input + '"]')
    let value = ''

    for (const valueItem of valueList) {
      if ((valueItem.type === 'checkbox' || valueItem.type === 'radio') && !valueItem.checked) {
        continue
      }
      if (value !== '') {
        value += ',' // 配列系のデータはカンマ区切りにする
      }
      value += valueItem.value
    }

    param += input + '=' + encodeURIComponent(value)
    console.log(param)
  }
  applyAjax(url, method, param, from, to, pushSt, type, scroll)
}

/*
        #### ##    ## ########  ##     ## ########
         ##  ####  ## ##     ## ##     ##    ##
#######  ##  ## ## ## ########  ##     ##    ##
         ##  ##  #### ##        ##     ##    ##
        #### ##    ## ##         #######     ##

テキスト入力時に通信する
<input id="" class="js-textAjax" type="text" name="" placeholder="" data-url="<?php echo H_URL; ?>" data-from="#a" data-to="#a" data-push="on">
*/
let ajaxWord = ''
if (document.getElementsByClassName('js-textAjax')) {
  window.addEventListener('input', (e) => {
    if (e.target.classList.contains('js-textAjax')) {
      e.preventDefault()
      const item = e.target
      if (item.classList.contains('reset')) {
        item.classList.remove('reset')
      } else if (ajaxWord === item.value) {
        // キーワードが変わっていなければ処理しない
        return false
      }
      ajaxWord = item.value
      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })
}

/*
         ######  ######## ##       ########  ######  ########
        ##       ##       ##       ##       ##          ##
#######  ######  ######   ##       ######   ##          ##
              ## ##       ##       ##       ##          ##
         ######  ######## ######## ########  ######     ##

セレクトボックスの切替時、valueのURLに通信する
<select name="" class="js-selectAjax" data-from="#a" data-to="#a" data-push="on">
    <option value="https://example.com">最新順</option>
</select>
*/
if (document.getElementsByClassName('js-selectAjax')) {
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-selectAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.value // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })
}

/*
        ##        #######     ###    ########
        ##       ##     ##  ##   ##  ##     ##
####### ##       ##     ## ##     ## ##     ##
        ##       ##     ## ######### ##     ##
        ########  #######  ##     ## ########

ページアクセス時にロードする
<div id="js-loadAjax" data-url="" data-from="" data-to=""></div>
*/
const loadAjax = document.getElementById('js-loadAjax')
if (loadAjax) {
  const item = loadAjax
  const url = item.dataset.url // 取得先
  const from = item.dataset.from // 取得要素
  const to = item.dataset.to // 差し替え要素
  applyAjax(url, 'GET', null, from, to, false, 'rep', false)
}

/*
        ########     ###     ######  ##    ##
        ##     ##  ##   ##  ##       ##  ##
####### ########  ##     ## ##       #####
        ##     ## ######### ##       ##  ##
        ########  ##     ##  ######  ##    ##

ブラウザバックでのアクセス時にURL通りのものをロードする
<div id="js-backAjax" data-from="#a" data-to="#a"></div>
*/
const backAjax = document.getElementById('js-backAjax')
if (backAjax) {
  if (window.history && window.history.pushState) {
    window.onpopstate = function (e) {
      const item = backAjax
      const url = location.href // 取得先
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      applyAjax(url, 'GET', null, from, to, false, 'rep', false)
    }
  }
}

/*
         #### ##    ##
          ##  ####  ##
 #######  ##  ## ## ##
          ##  ##  ####
         #### ##    ##

Intersection Observerで発火させる
連鎖的に読み込む場合はApplyのコールバックでもintObsAjax()を実行する
<div class="js-intAjax" data-from="#a" data-to="#a" data-type="add" data-push="off" data-url="">&emsp;</div>
*/

if (document.getElementsByClassName('js-intAjax')[0]) {
  intObsAjax()
}
function intObsAjax() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '0px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-intAjax')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const item = entry.target

        const url = item.dataset.url // 取得先
        const type = item.dataset.type // add(追加)もしくはrep(差し替え)
        const from = item.dataset.from // 取得要素
        const to = item.dataset.to // 差し替え要素
        const pushSt = item.dataset.push // URLのプッシュ
        const scroll = item.dataset.scroll // スクロール先
        const flag = item.dataset.flag // 追加の処理フラグ
        applyAjax(url, 'GET', null, from, to, pushSt, type, scroll, flag)
        observer.unobserve(item) // 監視対象から外す
        item.parentNode.removeChild(item) // DOM削除
      }
    }
  }
}

/*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
/**
 * Ajax処理を実行する
 * @param url {string} 取得先のURL
 * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
 * @param to {string} 取得先のセレクタ　,区切りで複数指定
 * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
 * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
 * @param scroll {string} 指定の位置にスクロールさせる
 * @param flag {string} 独自の拡張用
 */
function applyAjax(url, method = 'GET', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
  from = from.split(',') // ,区切りで配列に変換
  to = to.split(',') // ,区切りで配列に変換

  if (pushSt === 'on') {
    history.pushState(null, null, url) // URL変更
  }

  // Ajaxと明示するパラメータを付ける
  url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'

  const loadingItem = document.createElement('div')
  loadingItem.className = 'md-loading active'

  // ローディング処理
  for (let index = 0; index < to.length; index++) {
    const itemTo = document.querySelector(to[index])
    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'
    if (type === 'rep') {
      loadingItem.style.width = itemTo.offsetWidth + 'px'
      loadingItem.style.height = itemTo.offsetHeight + 'px'
      itemTo.innerHTML = ''
    }
    itemTo.appendChild(loadingItem)
  }

  if (ajax) {
    // 既に通信中なら切断
    ajax.abort()
  }

  ajax = new XMLHttpRequest() // Ajaxリクエスト
  if (method === 'POST') {
    ajax.open(method, url, true) // GET/POST, URL, 非同期処理
  } else {
    if (param) {
      url += '&' + param // パラメータをURLに結合
    }
    ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    if (pushSt === 'on') {
      history.pushState(null, null, url + '?' + param) // URL変更
    }
  }
  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  // ajax.setRequestHeader('Pragma', 'no-cache')
  // ajax.setRequestHeader('Cache-Control', 'no-cache')
  // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  if (method === 'POST') {
    ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
  }
  ajax.responseType = 'document' // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間
  if (method === 'POST') {
    ajax.send(param) // POSTリクエスト実行
  } else {
    ajax.send() // GETリクエスト実行
  }
  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }

    if (ajax.response === ajaxResponse) {
      // 前と結果が同じなら何もしない
      return
    }
    ajaxResponse = ajax.response // 取得結果を更新

    let ajaxData = ajaxResponse // 実際に使用するデータ

    // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
    // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
    //   ajaxData = JSON.parse(ajaxData)
    // }
    for (let index = 0; index < to.length; index++) {
      const itemFrom = ajaxData.querySelector(from[index])
      const itemTo = document.querySelector(to[index])

      if (type === 'rep') {
        itemTo.innerHTML = itemFrom.innerHTML
      } else {
        // addなら既存の要素を消さずに追加
        const delLoading = itemTo.querySelector('.md-loading')
        delLoading.parentNode.removeChild(delLoading)
        itemTo.innerHTML += itemFrom.innerHTML
      }
      intObs()
      if (scroll) {
        autoScroll(scroll, '#header', true)
      }
    }
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
    // intObsAjax()
    ajax = false
  }
}

//  ######   ####
//    ##    #   ##
//    ##     ####
//    ##    #   ##
//    ##     ####

function trunk8() {
  $('.js-t8.line2').trunk8({
    lines: 2,
    fill: '...',
  })
  $('.js-t8.expand2').trunk8({
    // 指定要素に行数制限をかける
    lines: 2,
    fill: '<span class="js-t8-open alert__more" data-target="#alert">… <span class="alert__moreText">MORE <i class="alert__icon icon-down"></i></span></span>',
  })
}
// 行数制限を解除する
$(document).on('click', '.js-t8-open', function () {
  const target = this.dataset.target
  $(this).remove()
  $(target).trunk8('revert').removeClass('js-t8')
})
if (document.getElementsByClassName('js-t8')[0]) {
  if (window.matchMedia('(max-width:768px)').matches) {
    //SP
    trunk8()
    $(window).on('load resize ', function () {
      trunk8()
    })
  }
}

/*
  ######          ######## ##     ##  ######  ##
 ##               ##         ## ##   ##       ##
 ##       ####### ######      ###    ##       ##
 ##               ##         ## ##   ##       ##
  ######          ######## ##     ##  ######  ########

// クリックされたとき、属するグループのクラスをアクティブにし、他のグループを非アクティブにする
<button type="button" class="js-clickExclActive" data-excl-group="hogeGroup" data-excl-target="fugaTarget"></button>
<div class="js-clickExclActive-group--hogeGroup js-clickExclActive-target--fugaTarget"></div>

*/
if (document.getElementsByClassName('js-clickExclActive')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickExclActive')) {
      return
    }
    const group = e.target.dataset.exclGroup
    const target = e.target.dataset.exclTarget
    exclActive(group, target, 'active')
  })
}
function exclActive(group, target, className = 'active') {
  const hide = document.getElementsByClassName('js-clickExclActive-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove(className)
  }
  const view = document.getElementsByClassName('js-clickExclActive-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add(className)
  }
}
